/*
    Add here your own custom javascript
*/

window.handleOutOfStockOptions = () => {
    const form = document.querySelector('#product-content form')
    if (!form.dataset.variants) return

    const variants = JSON.parse(form.dataset.variants)
    // console.log(variants)

    const selectedOption1 = form.querySelector('input[data-option-position="1"]:checked')?.value
    const selectedOption2 = form.querySelector('input[data-option-position="2"]:checked')?.value
    const selectedOption3 = form.querySelector('input[data-option-position="3"]:checked')?.value

    // form.querySelectorAll('input[data-option-position="1"]').forEach(input => {
    //   const correspondingVariant = variants.find(variant => {
    //     if (selectedOption3) {
    //       if (variant.option1 === input.value && variant.option2 === selectedOption2 && variant.option3 === selectedOption3) return variant
    //     } else if (selectedOption2) {
    //       if (variant.option1 === input.value && variant.option2 === selectedOption2) return variant
    //     } else {
    //       if (variant.option1 === input.value) return variant
    //     }
    //     return null
    //   })

    //   if (correspondingVariant?.available) {
    //     input.classList.remove('disabled')
    //   } else {
    //     input.classList.add('disabled')
    //   }
    // })

    form.querySelectorAll('input[data-option-position="2"]').forEach(input => {
      const correspondingVariant = variants.find(variant => {
        if (selectedOption3) {
          if (variant.option2 === input.value && variant.option1 === selectedOption1 && variant.option3 === selectedOption3) return variant
        } else {
          if (variant.option2 === input.value && variant.option1 === selectedOption1) return variant
        }
        return null
      })

      if (correspondingVariant?.available) {
        input.classList.remove('disabled')
      } else {
        input.classList.add('disabled')
      }
    })

    form.querySelectorAll('input[data-option-position="3"]').forEach(input => {
      const correspondingVariant = variants.find(variant => {
        if (variant.option3 === input.value && variant.option1 === selectedOption1 && variant.option2 === selectedOption2) return variant
        return null
      })

      if (correspondingVariant?.available) {
        input.classList.remove('disabled')
      } else {
        input.classList.add('disabled')
      }
    })
  }

window.handleOutOfStockOptions()